/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import moment from 'moment';

import cleanUpResponse from '@/util/cleanUpResponse';
import { formatDisplayDate } from '@/util/MomentUtils';

export default async function CalculateDatesForAWPackage(awPackageId) {
  // Format popDate
  const response = await $.soap({
    body: {
      CalculateDatesForAWPackage: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPID: awPackageId
      }
    },
    blueprint: {
      koStatusDateReq: '$..KOStatusReqDate'
    }
  });

  cleanUpResponse(response);

  if (response.koStatusDateReq) {
    response.koStatusDateReq = formatDisplayDate(response.koStatusDateReq, moment.ISO_8601);
  }

  return response.koStatusDateReq;
}
